<clr-modal [(clrModalOpen)]="opened">
  <h3 class="modal-title" i18n>Module Loading Error</h3>
  <div class="modal-body" i18n>
    <p>
      Failed to load the requested page or component.
      This is typically due to one of the following reasons:
    </p>
    <ul>
      <li>A new version of the application is available.</li>
      <li>Network problems on your end.</li>
      <li>An outage affecting the service.</li>
    </ul>
    <p>
      Try refreshing the page.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="reloadPage()">
      Refresh Page
    </button>
    <button type="button" class="btn btn-outline" (click)="opened.set(false)">
      Dismiss
    </button>
  </div>
</clr-modal>
